import {Descriptions} from 'antd'
import {colors} from 'helpers/style'
import React from 'react'

const StatusRecordDetails = ({statusRecord, interval}) => {
  if (!statusRecord) return <></>

  // Calculate range start and end
  const timestamp = new Date(statusRecord.timestamp)
  let rangeEnd = null
  if (interval && interval.value) {
    rangeEnd = new Date(timestamp.getTime() + interval.value * 60000)
  }

  // Graphical range bar component (copied/adapted from TemperatureDetails)
  const RangeBar = () => {
    if (!rangeEnd) return null
    const startDate = timestamp.toLocaleDateString()
    const endDate = rangeEnd.toLocaleDateString()
    const startTime = timestamp.toLocaleTimeString()
    const endTime = rangeEnd.toLocaleTimeString()
    const crossesMidnight = startDate !== endDate
    return (
      <div style={{display: 'flex', alignItems: 'center', marginBottom: 16}}>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 110}}>
          <span style={{fontWeight: 500, fontSize: 13}}>{startTime}</span>
          <span style={{fontSize: 12, color: '#888'}}>{startDate}</span>
        </div>
        <div
          style={{
            flex: 1,
            height: 6,
            background: 'linear-gradient(90deg, #4f8cff 0%, #a0c4ff 100%)',
            margin: '0 10px',
            borderRadius: 3
          }}
        />
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', minWidth: 110}}>
          <span style={{fontWeight: 500, fontSize: 13}}>{endTime}</span>
          {crossesMidnight && <span style={{fontSize: 12, color: '#888'}}>{endDate}</span>}
        </div>
      </div>
    )
  }

  // Format date/time for single value fallback
  const formatDateTime = isoString => {
    if (!isoString) return ''
    const d = new Date(isoString)
    const pad = n => n.toString().padStart(2, '0')
    const year = d.getFullYear()
    const month = pad(d.getMonth() + 1)
    const day = pad(d.getDate())
    const hours = pad(d.getHours())
    const minutes = pad(d.getMinutes())
    const seconds = pad(d.getSeconds())
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }

  return (
    <>
      <RangeBar />
      <Descriptions
        column={1}
        bordered={false}
        size="small"
        labelStyle={{
          fontWeight: 'bold',
          color: 'gray',
          whiteSpace: 'nowrap',
          width: '10rem',
          verticalAlign: 'top'
        }}
        contentStyle={{
          fontWeight: 'bold',
          color: 'black',
          margin: 0,
          padding: 0,
          whiteSpace: 'normal'
        }}
      >
        {/* Graphical range bar is above */}
        {!rangeEnd && <Descriptions.Item label="Date/Time">{formatDateTime(statusRecord.timestamp)}</Descriptions.Item>}
        <Descriptions.Item label="Position Accuracy">
          <span style={{color: colors.rgs.position_accuracy}}>{statusRecord.position_accuracy}</span>
        </Descriptions.Item>
        <Descriptions.Item label="Speed">
          <span style={{color: colors.rgs.speed}}>{statusRecord.speed}</span>
        </Descriptions.Item>
        <Descriptions.Item label="Spped Accuracy">
          <span style={{color: colors.rgs.speed_accuracy}}>{statusRecord.speed_accuracy}</span>
        </Descriptions.Item>
        <Descriptions.Item label="Heading">
          <span style={{color: colors.rgs.heading}}>{statusRecord.heading}</span>
        </Descriptions.Item>
        <Descriptions.Item label="Heading Accuracy">
          <span style={{color: colors.rgs.heading_accuracy}}>{statusRecord.heading_accuracy}</span>
        </Descriptions.Item>
        <Descriptions.Item label="Voltage">
          <span style={{color: colors.rgs.voltage}}>{statusRecord.voltage}</span>
        </Descriptions.Item>
        <Descriptions.Item label="Current">
          <span style={{color: colors.rgs.current}}>{statusRecord.current}</span>
        </Descriptions.Item>
      </Descriptions>
    </>
  )
}

export default StatusRecordDetails
